<template lang="">
    <div>
         <v-card
    class="mx-auto mt-5"
    max-width="500"
    outlined
  >
    <v-list-item v-if="true" three-line>
      <v-list-item-content>
        <div class="overline mb-4">Generador de codigos para excepciones</div>
        <v-text-field v-model="codigo" disabled></v-text-field>
      </v-list-item-content>

    
    </v-list-item>

    <v-card-actions>
      <v-btn @click.prevent="GenerarCodigo" text>Generar</v-btn>
      <v-btn @click.prevent="SubirExeption" text>Aceptar</v-btn>
    </v-card-actions>
  </v-card>
    </div>
</template>
<script>

import {SubirExeptions} from '../../../../../../services/exeptions/exeptions'

export default {
    
    data() {
        return {
            codigo:'',

            caracteres:'0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ',
            //longitud:'999999',
            min:111111,
            max:999999
        }
    },

    methods: {
        
        rand_code:function(chars, lon){
            var code = "";
                 for (var x=0; x < lon; x++)
                {
                   var rand = Math.floor(Math.random()*chars.length);
                    code += chars.substr(rand, 1);
                }
                return code;
            },

            rand_code2:function(min, max) {
               var numeroC = Math.ceil(Math.random() * (max - min) + min);
                return numeroC;
            },

            
        
              GenerarCodigo:function(){
                this.codigo = this.rand_code2(this.min, this.max)
                //this.codigo = this.rand_code(this.caracteres, this.longitud);
              },


            SubirExeption(){
              
              this.$store.dispatch('LoadingFetchActions', true);
                SubirExeptions({'codigo':this.codigo}).then(response=>{
                    this.$router.push({path: '/exepciones'});
                    this.$store.dispatch('GetDrivings');
                    this.$toastr.success('Se ha generado con éxito el código');
                    this.codigo = '';
                    this.$store.dispatch('LoadingFetchActions', false);
                }).catch(erros=>{
                    this.$toastr.error(erros);
                    this.codigo = '';
                    this.$store.dispatch('LoadingFetchActions', false);
                });
            }

        
        },


      
        

}

//alert(rand_code(caracteres, longitud));
</script>